import { Component } from '@angular/core';
import { CookieConsentPopupService } from '@app/shared/services/cookie-consent-popup/cookie-consent-popup.service';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';

@Component({
  selector: 'app-cookies-policy-page',
  templateUrl: './cookies-policy-page.component.html',
  styleUrls: ['./cookies-policy-page.component.scss']
})
export class CookiesPolicyPageComponent {

  constructor(private seoService: SEOService, private cookieConsentPopupService: CookieConsentPopupService) {

    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'SHARED.COOKIE-POLICY-PAGE.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'SHARED.DEFAULT-META.META-DESCRIPTION'
      }
    ]);
  }

  revokeCookieConsentPopup(): void {
    this.cookieConsentPopupService.revokeCookieConsentPopup();
  }

}
